var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumedown1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9 2.08c.35.16.59.51.59.91v18c0 .39-.24.75-.6.91 -.36.16-.78.09-1.08-.17l-5.35-4.75h-4.5c-.56 0-1-.45-1-1V7.97c0-.56.44-1 1-1h4.49l5.34-4.75c.29-.27.71-.33 1.07-.17Zm-1.41 3.13L9.52 8.73c-.19.16-.42.25-.67.25H4.975v6H8.85c.24 0 .48.08.66.25l3.96 3.52V5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.48 10.21l-.39-.77 1.78-.9 .38.76c.84 1.68.84 3.67 0 5.36l-.39.76 -1.79-.9 .38-.77c.56-1.13.56-2.46 0-3.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumedown1);
export default __webpack_public_path__ + "static/media/volume down 1.7a668e13bc602a2ea566b0230ca1bafe.svg";
export { ForwardRef as ReactComponent };